import request from '@/services/interceptor.js'

/* DOCENTI */
export const get_docenti = () => {
    return request({
        url: 'formazione/docenti',
        method: 'get',
        noLoadingBar: true
    })
};

/* CORSI */
export const get_corsi = () => {
    return request({
        url: 'formazione/corsi',
        method: 'get',
        noLoadingBar: true
    })
};

export const set_corso = (par) => {
    return request({
        url: 'formazione/corsi',
        method: 'post',
        data: par,
        loadingBar: true
    })
};

export const delete_corso = (corsoId) => {
    return request({
        url: 'formazione/corsi/elimina?corsoId=' + corsoId,
        method: 'post',
        loadingBar: true
    })
};

/* EDIZIONI */
export const get_edizioni = (filtro) => {
    return request({
        url: 'formazione/edizioni',
        method: 'post',
        data: filtro,
        noLoadingBar: true
    })
};

export const get_edizioneDettaglio = (edizioneId) => {
    return request({
        url: 'formazione/edizioni/' + edizioneId,
        method: 'get',
        loadingBar: true
    })
};

export const set_edizione = (par) => {
    return request({
        url: 'formazione/edizioni/nuovo',
        method: 'post',
        data: par,
        loadingBar: true
    })
};

export const delete_edizione = (edizioneId) => {
    return request({
        url: 'formazione/edizioni/elimina?edizioneId=' + edizioneId,
        method: 'post',
        loadingBar: true
    })
};

export const set_aziendeEdizione = (par) => {
    return request({
        url: 'formazione/edizioni/aziende',
        method: 'post',
        data: par,
        loadingBar: true
    })
};

export const set_partecipante = (par) => {
    return request({
        url: 'formazione/edizioni/partecipanti',
        method: 'post',
        data: par,
        loadingBar: true
    })
};

export const delete_partecipante = (partecipanteId) => {
    return request({
        url: 'formazione/edizioni/partecipanti/elimina?partecipanteId=' + partecipanteId,
        method: 'post',
        loadingBar: true
    })
};

export const conferma_edizione = (par) => {
    return request({
        url: 'formazione/edizioni/conferma',
        method: 'post',
        data: par,
        loadingBar: true
    })
};

export const genera_attestati = (edizioneId) => {
    return request({
        url: 'formazione/edizioni/genera-attestati?edizioneId=' + edizioneId,
        method: 'post',
        loadingBar: true
    })
};

export const rigenera_attestato = (partecipanteId) => {
    return request({
        url: 'formazione/edizioni/partecipanti/rigenera-attestato?partecipanteId=' + partecipanteId,
        method: 'post',
        loadingBar: true
    })
};

/* EXPORT */
export const get_corsiSvoltiExcel = (filtro) => {
    return request({
        url: 'formazione/excel',
        method: 'post',
        data: filtro,
        loadingBar: true
    })
};

/* VISTA CLIENTE */
export const get_attestatiAzienda = () => {
    return request({
        url: 'formazione/cliente/attestati',
        method: 'get',
        loadingBar: true
    })
};

export const download_attestato = (partecipanteId) => {
    return request({
        url: 'formazione/cliente/download/' + partecipanteId,
        method: 'get',
        responseType: 'blob'
    })
};
